<template>
	<div class="gc-container">
		<div class="bg-desktop" :style="'background-image:url(' +  wpNavOptions.page_bg_desktop + ')'"></div>
		<div class="bg-mobile" :style="'background-image:url(' +  wpNavOptions.page_bg_mobile + ')'"></div>
		<div class="gc-wrapper">
			<h1 class="gc-title">{{wpOptions.title}}</h1>
			<p class="gc-subtitle">{{wpOptions.subtitle}}</p>
			<p class="gc-text">{{wpOptions.text}}</p>

			<div class="gc-form" v-if="!formSent" v-html="wpData.gift_card_contact_form"></div>

			<div class="gc-sent" v-if="formSent">
				<p>{{wpOptions.thank_you_text}}</p>
				<!-- <router-link class="gc-button" to="/">חזרה לעמוד הבית</router-link> -->
			</div>

			<br><br>

			<div class="form-wrapper">
				<router-link to="/gift-card/purchase" class="go-to-main-gc">{{wpOptions.go_to_main_gc_text}}</router-link>
			</div>

		</div>
	</div>
</template>

<script>

	export default {

		name: 'Companies',
		metaInfo: {
			title: wpData.globalOptions.gc_page_companies.seo_title,
			meta: [{
				name: 'description',
				content: wpData.globalOptions.gc_page_companies.seo_desc
			}]
		},
		data () {
			return {
				wpData: wpData,
				wpOptions: wpData.globalOptions.gc_page_companies,
				wpNavOptions: wpData.globalOptions.gc_purchase_nav,
				formSent: false
			}
		},
		watch: {
			
		},
		methods: {

		},
		computed: {
			
		},
		mounted(){

			// Sent
			document.addEventListener("wpcf7mailsent", e => {
				this.formLoading = false;
				this.formSent = true;
			});
		},
		components: {

		}
	}
</script>

<style lang="sass" scoped>

	@import '../../assets/sass/gift-card-abstracts.sass'

	.bg-desktop
		position: fixed
		z-index: 1
		top: auto
		bottom: 0
		left: 0
		width: 30%
		height: 100%
		max-height: calc(100vh - 250px)
		background-size: contain
		background-repeat: no-repeat
		background-position: left bottom
		+tablet
			display: none
			
	.bg-mobile
		display: none
		height: 50vw
		background-size: cover
		background-position: center top
		position: relative
		margin-bottom: 1rem
		&:after
			content: ''
			position: absolute
			bottom: 0
			left: 0
			height: 5rem
			width: 100%
			background: linear-gradient(0deg, rgba($bg,1) 0%, rgba(255,255,255,0) 100%)

		+tablet
			display: block

	.gc-container
		padding: 4rem 0
		+tablet
			padding-top: 0
		+mobile
			padding-top: 0

	.gc-title
		margin-bottom: 0.35rem

	.gc-subtitle
		font-size: 1.5rem
		& + .gc-text
			margin-top: 1rem

	.gc-text
		white-space: pre-line
		font-size: 1.15rem
		line-height: 1.6

	.gc-form
		max-width: 24rem
		margin: 2rem 0

		&.loading
			background-color: red

	.gc-sent
		padding: 1rem
		background: $white
		border-radius: 0.25rem
		box-shadow: 0 0.25rem 0.5rem 0 rgba(darken($bg, 30%), 0.2)
		max-width: 24rem
		margin: 1rem 0

	.gc-button
		background-color: $dark
		color: $white
		padding: 0.5rem 1.5rem
		border-radius: 5rem
		display: inline-block
		margin-top: 0.5rem
		&:hover, &:focus
			background-color: $main
		&:active
			background-color: lighten($main, 5%)

	.form-wrapper
		max-width: 24rem
		text-align: center
	
	.go-to-main-gc:hover, .go-to-main-gc:focus
		text-decoration: underline

</style>